import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { MenuItem } from '@material-ui/core'
import { ReactComponent as InProgress } from 'assets/img/ic_checked_in_progress.svg'
import { ReactComponent as Checked } from 'assets/img/ic_checked.svg'
import { ReactComponent as Unchecked } from 'assets/img/ic_unchecked.svg'
import {
  STATUS_COMPLETED,
  STATUS_IN_PROGRESS,
  STATUS_NOT_STARTED,
} from 'helpers/jobs'
import CircleLoader from 'components/Loading/CircleLoader'
import messages from '../translate'

class StepConfiguration extends Component {
  state = {
    allSelected: STATUS_NOT_STARTED,
  }

  componentDidUpdate(prevProps) {
    const {
      unitGroupList,
      unitList,
      unitTree,
      workflowInfo,
      handleDisableNext,
      checkCoincidences,
      data,
      setData,
    } = this.props
    const {
      unitGroupList: prevUnitGroupList,
      unitList: prevUnitList,
      unitTree: prevUnitTree,
      workflowInfo: prevWorkflowInfo,
    } = prevProps
    const allUnselected = data.every(
      item => item.selected === STATUS_NOT_STARTED,
    )

    if (workflowInfo !== prevWorkflowInfo) {
      checkCoincidences(workflowInfo.get('tasks'))
    }

    if (unitGroupList !== prevUnitGroupList) {
      setData(this.getTransformedData(unitGroupList.toArray(), 'locus_group'))
    }

    if (unitList !== prevUnitList) {
      setData(this.getTransformedData(unitList.toArray(), 'locus'))
    }

    if (unitTree !== prevUnitTree) {
      const { groups } = unitTree.toJS()

      setData(this.getTransformedData([...groups]))
    }

    if ((data.length && allUnselected) || !data.length) {
      handleDisableNext(true)
    } else {
      handleDisableNext(false)
    }
  }

  getAllSelectedState = () => {
    const { data } = this.props

    if (data.length > 0) {
      this.setState({
        allSelected: this.getParentStatus(data),
      })
    }
  }

  getTransformedData = (data, type) =>
    data.map(({ locuses, name, id, containerName }, itemIndex) => {
      const childData = []

      if (locuses && locuses.length) {
        locuses.forEach((innerItem, innerItemIndex) => {
          childData.push({
            id: innerItem.id,
            key: `${id}_${innerItem.id}`,
            name: innerItem.name || innerItem.containerName,
            selected: STATUS_NOT_STARTED,
            index: innerItemIndex,
            parentId: id,
          })
        })
      }

      return {
        id,
        key: `${name || containerName}_${id}`,
        name: name || containerName,
        selected: STATUS_NOT_STARTED,
        index: itemIndex,
        childData,
        ...(!!type && { type }),
      }
    })

  handleAllSelectedClick = () => {
    const { allSelected } = this.state
    const { setData } = this.props
    const changeAllSelected = status => {
      setData(this.makeSelected(status))
      this.setState(
        {
          allSelected: status,
        },
        () => this.handleExportData(),
      )
    }

    if (
      allSelected === STATUS_NOT_STARTED ||
      allSelected === STATUS_IN_PROGRESS
    ) {
      changeAllSelected(STATUS_COMPLETED)
    }

    if (allSelected === STATUS_COMPLETED) {
      changeAllSelected(STATUS_NOT_STARTED)
    }
  }

  handleExportData = () => {
    const { onSetForm, data } = this.props
    const { allSelected } = this.state
    const exportData = data.reduce((total, item) => {
      if (allSelected === STATUS_COMPLETED) {
        return total
      }

      if (item.childData && item.childData.length > 0) {
        if (item.selected === STATUS_COMPLETED) {
          total.push({ locus_group: item.id })
        }

        if (item.selected === STATUS_IN_PROGRESS) {
          const children = item.childData.reduce((result, item) => {
            if (item.selected === STATUS_COMPLETED) {
              result.push({
                locus_group: item.parentId,
                locus: item.id,
              })
            }

            return result
          }, [])

          total.push(...children)
        }
      } else if (item.selected === STATUS_COMPLETED) {
        total.push({ [item.type]: item.id })
      }

      return total
    }, [])

    onSetForm(exportData)
  }

  makeSelected = value => {
    const { data } = this.props

    return data.map(item => {
      /* eslint-disable no-param-reassign */
      item.selected = value

      if (item.childData.length > 0) {
        item.childData.forEach(child => {
          child.selected = value
        })
      }

      return item
    })
  }

  getSelectedIcon = value => {
    switch (value) {
      case STATUS_COMPLETED: {
        return <Checked className="ic-selection" />
      }

      case STATUS_IN_PROGRESS: {
        return <InProgress className="ic-selection" />
      }

      case STATUS_NOT_STARTED: {
        return <Unchecked className="ic-selection" />
      }

      default:
        return null
    }
  }

  handleItemClick = value => {
    const { data, setData } = this.props
    const parentItem =
      value.parentId && data.find(item => item.id === value.parentId)
    const modifyChildrenStatus = (children, status) =>
      children.map(child => {
        child.selected = status

        return child
      })

    if (value.selected === STATUS_NOT_STARTED) {
      if (parentItem) {
        if (parentItem.selected === STATUS_NOT_STARTED) {
          parentItem.selected = STATUS_IN_PROGRESS
        }

        parentItem.childData[value.index].selected = STATUS_COMPLETED
        data[parentItem.index] = parentItem
      } else {
        if (value.childData.length > 0) {
          value.childData = modifyChildrenStatus(
            value.childData,
            STATUS_COMPLETED,
          )
        }

        value.selected = STATUS_COMPLETED
        data[value.index] = value
      }
    } else if (value.selected === STATUS_IN_PROGRESS) {
      if (value.childData.length > 0) {
        value.childData = modifyChildrenStatus(
          value.childData,
          STATUS_COMPLETED,
        )
      }

      value.selected = STATUS_COMPLETED
      data[value.index] = value
    } else if (parentItem) {
      parentItem.childData[value.index].selected = STATUS_NOT_STARTED
      data[parentItem.index] = parentItem
    } else {
      if (value.childData.length > 0) {
        value.childData = modifyChildrenStatus(
          value.childData,
          STATUS_NOT_STARTED,
        )
      }

      value.selected = STATUS_NOT_STARTED
      /* eslint-enable no-param-reassign */
      data[value.index] = value
    }

    if (parentItem) {
      parentItem.selected = this.getParentStatus(parentItem.childData)
    }

    this.getAllSelectedState()
    setData([...data], this.handleExportData)
  }

  getParentStatus = parent => {
    let status = STATUS_NOT_STARTED
    let completedCould = 0

    for (const key in parent) {
      if (Object.prototype.hasOwnProperty.call(parent, key)) {
        const item = parent[key]
        const children = item.childData

        if (
          item.selected === STATUS_COMPLETED ||
          item.selected === STATUS_IN_PROGRESS
        ) {
          status = STATUS_IN_PROGRESS
          completedCould += 1
        }

        if (children && children.length) {
          for (const childKey in children) {
            if (Object.prototype.hasOwnProperty.call(children, childKey)) {
              const elem = children[childKey]

              if (
                elem.selected === STATUS_IN_PROGRESS ||
                elem.selected === STATUS_NOT_STARTED
              ) {
                return STATUS_IN_PROGRESS
              }
            }
          }
        }
      }
    }

    if (parent.length === completedCould) {
      status = STATUS_COMPLETED
    }

    return status
  }

  renderListItem = unit => {
    const childRender = unit.childData.map(child =>
      this.renderItem(child, 'second'),
    )

    return (
      <Fragment key={unit.id}>
        {this.renderItem(unit, 'first')}
        {childRender}
      </Fragment>
    )
  }

  renderItem = (unit, level) => (
    <MenuItem
      key={unit.key}
      value={unit.id}
      onClick={evt => this.handleItemClick(unit, evt)}
      className={`list-item ${level}-level`}>
      {this.getSelectedIcon(unit.selected)}
      <span className="item-name">{unit.name}</span>
    </MenuItem>
  )

  render() {
    const { formatMessage, unitsLoading, unitsGroupLoading, data } = this.props
    const { allSelected } = this.state

    if (unitsLoading || unitsGroupLoading) {
      return <CircleLoader loading />
    }

    return (
      <div className="configuration-list">
        {data.length > 0 && (
          <>
            <MenuItem
              key="all-selected"
              className="list-item all-selected"
              onClick={this.handleAllSelectedClick}>
              {this.getSelectedIcon(allSelected)}
              <span className="item-name">
                {formatMessage(messages.allSelected)}
              </span>
            </MenuItem>
            {data.map(item => this.renderListItem(item))}
          </>
        )}
      </div>
    )
  }
}

export default connect(state => ({
  workflowInfo: state.getIn(['myJobs', 'workflowInfo']),
  unitGroupList: state.getIn(['locusGroup', 'locusGroupList']),
  unitList: state.getIn(['locus', 'listData']),
  unitsLoading: state.getIn(['locus', 'unitsLoading']),
  unitsGroupLoading: state.getIn(['locusGroup', 'isLoadList']),
  unitTree: state.getIn(['locus', 'locusTree']),
}))(StepConfiguration)
